import util from '@/common/util';
import Data from '@/common/data';

const advRegisterPageKey = ['listing', 'listing-detail'];

// 如果有广告的注册配置就使用广告的注册方式
// test
window.mockDynamicRegister = function () {
    Data.creatorId = -9;

    util.setCookie('enableDynamicRegister', 1, 60);
};

/**
 * 组件已放在sign-log下，仅可使用isShow判断是否能显示广告注册弹窗
 */
export default {
    isShow() {
        /*responsive form弹窗只有在landing-page的广告页才有，
        进入该页会设置cookie enableDynamicRegister=1，
        如果从该页出来之后仍然可以保持登录注册弹窗是responsive 
        form只有清除cookie或者进入了非广告的landing-page后才可以清除responsive form弹窗*/
        return (
            Data.registration?.autopopup?.isDynamicRegister ||
            util.getCookie('enableDynamicRegister') == '1'
        );
    }
};
